import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui';
import { ButtonFilterOptions } from '@/components/custom';
import { PROMO_CODE_STATUS_CONFIG } from '@/constants';
import { cn } from '@/lib/utils';
import type { IPromoCodeOffer, ISelectOption } from '@/interfaces';
import PromoCodesTable from './components/PromoCodesTable';
import PromoCodeFormDialog, { type TPromoCodeFormMode } from './components/PromoCodeFormDialog';
import PromoCodeStatsDialog from './components/PromoCodeStatsDialog';
import usePromoCodes from './hooks/usePromoCodes';

const STATUS_OPTIONS: ISelectOption[] = Object.entries(PROMO_CODE_STATUS_CONFIG).map(([value, { label }]) => ({
	value,
	title: label,
}));

type TFormState = { mode: TPromoCodeFormMode; offer?: IPromoCodeOffer } | null;

const PromoCodesPage = () => {
	const { offers, isLoading, status, pageCount, handleStatusChange } = usePromoCodes();
	const [form, setForm] = useState<TFormState>(null);
	const [statsOffer, setStatsOffer] = useState<IPromoCodeOffer | null>(null);

	return (
		<div className={cn('flex flex-col space-y-4 pb-20', 'animate__animated animate__fadeIn')}>
			<div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
				<ButtonFilterOptions
					disabled={isLoading}
					options={STATUS_OPTIONS}
					value={status}
					text="Statut"
					onChange={options => handleStatusChange(options.map(option => option.value as string))}
				/>
				<Button size="sm" className="gap-1" onClick={() => setForm({ mode: 'create' })}>
					<Plus className="h-4 w-4" />
					Nouveau code promo
				</Button>
			</div>

			<PromoCodesTable
				offers={offers}
				isLoading={isLoading}
				pageCount={pageCount}
				onEdit={offer => setForm({ mode: 'edit', offer })}
				onDuplicate={offer => setForm({ mode: 'duplicate', offer })}
				onViewStats={setStatsOffer}
			/>

			<PromoCodeFormDialog
				open={!!form}
				mode={form?.mode ?? 'create'}
				offer={form?.offer}
				onClose={() => setForm(null)}
			/>

			<PromoCodeStatsDialog offer={statsOffer} onClose={() => setStatsOffer(null)} />
		</div>
	);
};

export default PromoCodesPage;
